 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734":"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734","CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30":"CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30","CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c":"CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c","CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor","CasosDelegados":"CasosDelegados","revisar_caso_empleado":"revisar_caso_empleado","revisar_caso_supervisor":"revisar_caso_supervisor","asignados~casos_empleados~casos_respondidos":"asignados~casos_empleados~casos_respondidos","asignados":"asignados","casos_empleados":"casos_empleados","casos_respondidos":"casos_respondidos","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889","crud_graficas":"crud_graficas","informacion_caso_supervisor":"informacion_caso_supervisor","inventario_documental":"inventario_documental","reporte_documental":"reporte_documental","reporte_workflow":"reporte_workflow","buscar_documentos":"buscar_documentos","inicio_rol":"inicio_rol","crud_documentos":"crud_documentos","crud_sectores":"crud_sectores","crud_workflows~digitalizar~iniciar_caso":"crud_workflows~digitalizar~iniciar_caso","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"buscar_estado_documento~buscar_estado_documentos~iniciar_caso","iniciar_caso":"iniciar_caso","digitalizar":"digitalizar","empalmes":"empalmes","rechazados":"rechazados","aud_reportes":"aud_reportes","buscar_estado_documento":"buscar_estado_documento","buscar_estado_documentos":"buscar_estado_documentos","crud_workflows":"crud_workflows","info_usuarios":"info_usuarios","informacion_caso_empleado":"informacion_caso_empleado","login":"login","admin":"admin","home_admin":"home_admin","home_rol":"home_rol","home_supervisor":"home_supervisor","informacion_caso_respondido":"informacion_caso_respondido","inicio":"inicio"}[chunkId]||chunkId) + "." + {"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734":"65f36b2c","CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30":"87a26c61","CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c":"0f009e9e","CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"5c86aabb","CasosDelegados":"5886fc83","revisar_caso_empleado":"239d6120","revisar_caso_supervisor":"6cbeac96","asignados~casos_empleados~casos_respondidos":"213f9b49","asignados":"a6e8fd0f","casos_empleados":"ddf38b92","casos_respondidos":"2d350b4f","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"04399ff4","crud_graficas":"04603e44","informacion_caso_supervisor":"0d6025e5","inventario_documental":"df9caa80","reporte_documental":"50fc7520","reporte_workflow":"cbc42edd","buscar_documentos":"473268c8","inicio_rol":"812054ae","crud_documentos":"3c294f13","crud_sectores":"609a0a19","crud_workflows~digitalizar~iniciar_caso":"c0360db3","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"013b4e38","iniciar_caso":"cfa34004","digitalizar":"27d1ae01","empalmes":"fca09060","rechazados":"6cbdbd34","aud_reportes":"8a4ead0e","buscar_estado_documento":"9180eea9","buscar_estado_documentos":"3377e1a4","crud_workflows":"303184df","info_usuarios":"b2a19a76","informacion_caso_empleado":"d89687e2","login":"54a7dcf4","admin":"766c119f","home_admin":"b73419b9","home_rol":"c24e2661","home_supervisor":"7a0416c7","informacion_caso_respondido":"f20c3490","inicio":"69c1d3e5","chunk-2d216214":"8ece6c8e","chunk-2d216257":"256ee085","chunk-7fd823ee":"303d964e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734":1,"CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30":1,"CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c":1,"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":1,"CasosDelegados":1,"revisar_caso_empleado":1,"revisar_caso_supervisor":1,"asignados~casos_empleados~casos_respondidos":1,"asignados":1,"casos_empleados":1,"casos_respondidos":1,"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":1,"crud_graficas":1,"informacion_caso_supervisor":1,"inventario_documental":1,"reporte_workflow":1,"buscar_documentos":1,"inicio_rol":1,"crud_documentos":1,"crud_sectores":1,"crud_workflows~digitalizar~iniciar_caso":1,"buscar_estado_documento~buscar_estado_documentos~iniciar_caso":1,"iniciar_caso":1,"digitalizar":1,"rechazados":1,"aud_reportes":1,"buscar_estado_documento":1,"buscar_estado_documentos":1,"crud_workflows":1,"info_usuarios":1,"informacion_caso_empleado":1,"login":1,"admin":1,"home_rol":1,"home_supervisor":1,"inicio":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734":"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734","CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30":"CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30","CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c":"CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c","CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor","CasosDelegados":"CasosDelegados","revisar_caso_empleado":"revisar_caso_empleado","revisar_caso_supervisor":"revisar_caso_supervisor","asignados~casos_empleados~casos_respondidos":"asignados~casos_empleados~casos_respondidos","asignados":"asignados","casos_empleados":"casos_empleados","casos_respondidos":"casos_respondidos","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889","crud_graficas":"crud_graficas","informacion_caso_supervisor":"informacion_caso_supervisor","inventario_documental":"inventario_documental","reporte_documental":"reporte_documental","reporte_workflow":"reporte_workflow","buscar_documentos":"buscar_documentos","inicio_rol":"inicio_rol","crud_documentos":"crud_documentos","crud_sectores":"crud_sectores","crud_workflows~digitalizar~iniciar_caso":"crud_workflows~digitalizar~iniciar_caso","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"buscar_estado_documento~buscar_estado_documentos~iniciar_caso","iniciar_caso":"iniciar_caso","digitalizar":"digitalizar","empalmes":"empalmes","rechazados":"rechazados","aud_reportes":"aud_reportes","buscar_estado_documento":"buscar_estado_documento","buscar_estado_documentos":"buscar_estado_documentos","crud_workflows":"crud_workflows","info_usuarios":"info_usuarios","informacion_caso_empleado":"informacion_caso_empleado","login":"login","admin":"admin","home_admin":"home_admin","home_rol":"home_rol","home_supervisor":"home_supervisor","informacion_caso_respondido":"informacion_caso_respondido","inicio":"inicio"}[chunkId]||chunkId) + "." + {"CasosDelegados~asignados~aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_docume~535ec734":"ce2af5c2","CasosDelegados~asignados~buscar_documentos~casos_empleados~casos_respondidos~crud_documentos~crud_gr~13aaef30":"5bd79ce0","CasosDelegados~asignados~casos_empleados~casos_respondidos~crud_graficas~informacion_caso_supervisor~1dbf2e4c":"2090ba31","CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"f36248b1","CasosDelegados":"dda69b28","revisar_caso_empleado":"d8b63c44","revisar_caso_supervisor":"d8b63c44","asignados~casos_empleados~casos_respondidos":"dda69b28","asignados":"2ac33231","casos_empleados":"2ac33231","casos_respondidos":"2ac33231","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"6134a656","crud_graficas":"49830f27","informacion_caso_supervisor":"b6511001","inventario_documental":"6591fb64","reporte_documental":"31d6cfe0","reporte_workflow":"49830f27","buscar_documentos":"3ed3c69f","inicio_rol":"d4bf9f6d","crud_documentos":"2e22c147","crud_sectores":"28dec579","crud_workflows~digitalizar~iniciar_caso":"80cee6ef","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"55a82b9c","iniciar_caso":"4af19e76","digitalizar":"5deb0fe9","empalmes":"31d6cfe0","rechazados":"7798a7f8","aud_reportes":"1accccda","buscar_estado_documento":"33ac40b1","buscar_estado_documentos":"1fca0cc0","crud_workflows":"28cd70b9","info_usuarios":"6c649c8b","informacion_caso_empleado":"9d21c0d7","login":"bf90f09d","admin":"8f6c4112","home_admin":"31d6cfe0","home_rol":"6acb22b4","home_supervisor":"5c8076a7","informacion_caso_respondido":"31d6cfe0","inicio":"5c8076a7","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-7fd823ee":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
